import { useEffect, useContext } from "react";
import { Context } from "../context/DataContext";
// import { Redirect } from "react-router-dom";

const ResolveAuth = ({ history }) => {
  const { restoreAppState } = useContext(Context);
  // const { route } = state;

  useEffect(() => {
    console.log("AppWorkflow - useEffect from ResolveAuth.js");
    restoreAppState(history.push);

    //eslint-disable-next-line
  }, []);

  // return route.creditor_id === 0 ? <Redirect to="/routes/choose" /> : null;
  return null;
};

export default ResolveAuth;
